module.exports = "<div class=\"pin\" title=\"<%=text%>\"></div>\n<div class=\"text\"><%=text%></div>";
